import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const SaintMartin: Country = {
    identifier: "SaintMartin",
    name: "Saint Martin",
    countryCode: "MF",
    group: CountryGroup.CENTRAL_AMERICA,
    isUNMember: false,
    flag: "🇲🇫",
    svgPath: "m 298.05475,411.6834 -0.314,0 0.023,-0.064 0.146,-0.072 0.107,0.006 0.043,0.026 z",
}
